import React, { useState,useEffect } from "react";
import { NavLink } from "react-router-dom";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CarIcon from "@mui/icons-material/DirectionsCar";
import TripsIcon from "@mui/icons-material/Explore";
import HdrAutoIcon from "@mui/icons-material/HdrAuto";
import CityConfigIcon from "@mui/icons-material/LocationCity";
import ServicesIcon from "@mui/icons-material/Build";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CruzeLog from "../../assets/images/logo/Cruze_White.png";
import IconButton from "@mui/material/IconButton";
import Payment from "@mui/icons-material/Payment";
import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useLocation, useNavigate } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import StarIcon from "@mui/icons-material/Star";
import SettingsIcon from "@mui/icons-material/Settings";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import TheatersIcon from "@mui/icons-material/Theaters";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ApprovalIcon from "@mui/icons-material/Approval";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import InsightsIcon from "@mui/icons-material/Insights";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import PlaceIcon from "@mui/icons-material/Place";
import PaymentsIcon from "@mui/icons-material/Payments";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EventSeatIcon from '@mui/icons-material/EventSeat';
import CollectionsIcon from '@mui/icons-material/Collections';
import { styled } from "@mui/material/styles";

import OwnerServices from "../services/externalServices/trackingservices/ownerServices";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#121621",
  color: "#b3b9c6",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#121621",
  color: "#b3b9c6",
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
    },
  }),
}));


function Sidebar1() {
  const [open, setOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    Favourites: true,
  });
  const [owners, setOwners] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const { role = "" } = JSON.parse(localStorage.getItem("admin")) || {};
  const isTicketAdmin = role === "ticket-admin";
  const isEarningsOnly = role === "earnings-report-only";
  const isTrackingAdmin = role === "tracking-admin";
  const isSuperAdmin = role === "superAdmin";
  console.log("Role: ", role);

  useEffect(() => {
    if (isSuperAdmin) {
      fetchOwners();
    }
  }, [isSuperAdmin]);

  const fetchOwners = async () => {
    try {
      const res = await OwnerServices.getAllOwners();
      setOwners(res || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOwnerDashboardClick = (ownerId,ownerKey) => {
    const adminData = JSON.parse(localStorage.getItem("admin")) || {};
    handleToggle(ownerKey)
    const newAdminData = { ...adminData, accessList: [ownerId] };
    localStorage.setItem("admin", JSON.stringify(newAdminData));
    // navigate("/tracking-dashboard");
    // window.location.reload();
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleToggle = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  // Define consistent sizes
  const ICON_FONT_SIZE = "0.9rem"; // For regular menu items
  const HEADER_ICON_FONT_SIZE = "0.95rem"; // Slightly larger for headers
  const TOGGLE_ICON_FONT_SIZE = "1.2rem"; // For the sidebar open/close toggle
  const ICON_MIN_WIDTH = "30px"; // Consistent minWidth for ListItemIcon
  // New constant for the chevron/expand icon's min-width when sidebar is closed
  const CHEVRON_ICON_CLOSED_MIN_WIDTH = "24px"; // Adjust as needed

  // Favourites items
  const favouritesItems = [
    {
      text: "Dashboard-Vehicles",
      icon: <GridViewRoundedIcon />,
      to: "/dashboard",
    },
    { text: "Cab Request", icon: <CarIcon />, to: "/cabrequests" },
    { text: "Trips", icon: <TripsIcon />, to: "/trips" },
    {
      text: "Dashboard - Tickets",
      icon: <GridViewRoundedIcon />,
      to: "/tickets-dashboard",
    },
    { text: "Earning Per Booking", icon: <BarChartIcon />, to: "/totalReport" },
    {
      text: "A-Payables",
      icon: <Payment />,
      children: [
        {
          text: "Processing",
          icon: <DriveFolderUploadIcon />,
          to: "/fileUpload",
        },
        {
          text: "Settlement",
          icon: <SummarizeIcon />,
          to: "/settlementReport",
        },
      ],
    },
  ];

  // Travels items
  const travelsItems = [
    {
      text: "Dashboard-Vehicles",
      icon: <GridViewRoundedIcon />,
      to: "/dashboard",
    },
    { text: "Cab Requests", icon: <CarIcon />, to: "/cabrequests" },
    { text: "Trips", icon: <TripsIcon />, to: "/trips" },
  ];

  // Masters & Config items
  const mastersConfigItems = [
    { text: "Auto Bid Matrix", icon: <HdrAutoIcon />, to: "/autoBidMatrix" },
    { text: "Notification", icon: <NotificationsIcon />, to: "/notification" },
    {
      text: "Masters",
      icon: <AccountTreeIcon />,
      children: [
        { text: "Users", icon: <PeopleAltRoundedIcon />, to: "/users" },
        { text: "Riders", icon: <CarIcon />, to: "/riders" },
        { text: "CruzeAdmins", icon: <PeopleAltRoundedIcon />, to: "/cruze-admins" },
        { text: "TrackingOwners", icon: <PeopleAltRoundedIcon />, to: "/tracking-owners" },
        { text: "Theater Owners", icon: <TheatersIcon />, to: "/account" },
        { text: "Theaters", icon: <TheatersIcon />, to: "/theaters-master" },
      ],
    },
    {
      text: "Configs",
      icon: <SettingsIcon />,
      children: [
        { text: "Services", icon: <ServicesIcon />, to: "/dashboard/services" },
        { text: "Locale", icon: <PlaceIcon />, to: "/nearyByLocation" },
        { text: "City Config", icon: <CityConfigIcon />, to: "/cityconfig" },
        { text: "Zones", icon: <AddLocationIcon />, to: "/zones" },
        { text: "Cruze Types", icon: <CarIcon />, to: "/cruzeTypes" },
        { text: "Spots", icon: <PlaceIcon />, to: "/spots" },
        { text: "Places", icon: <PlaceIcon />, to: "/tourPackagePlaces" },
        { text: "Packages", icon: <LocalOfferIcon />, to: "/packages" },
        // Payments v2 Configs
        { text: "Payment Profiles (v2)", icon: <PriceChangeIcon />, to: "/paymentsV2/profiles" },
        { text: "Payment Accounts (v2)", icon: <PriceChangeIcon />, to: "/paymentsV2/accounts" },
        { text: "Payment Policies (v2)", icon: <PriceChangeIcon />, to: "/paymentsV2/policies" },
        { text: "Refunds (v2)", icon: <PriceChangeIcon />, to: "/paymentsV2/refunds" },
        { text: "Pricing Config", icon: <PriceChangeIcon />, to: "/pricingConfig" },
      ],
    },
  ];

  // Marketing items
  const marketingItems = [
    { text: "Coupons", icon: <LocalOfferIcon />, to: "/coupons" },
    { text: "Advertise", icon: <FeaturedVideoIcon />, to: "/advertise" },
  ];

  // Tickets items
  const ticketsItems = [
    { text: "Book Movie", icon: <BookOnlineIcon />, to: "/moviebooking" },
    { text: "Movie Management", icon: <TheatersIcon />, to: "/movies" },
    { text: "Manage Showtimes", icon: <ScheduleIcon />, to: "/showSchedules" },
    {
      text: "Dynamic Pricing",
      icon: <PriceChangeIcon />,
      to: "/dynamicPricing",
    },
    { text: "Dynamic Report", icon: <AssessmentIcon />, to: "/dynamicReport" },
    {
      text: "Master Layout",
      icon: <EventSeatIcon />,
      to: "/master"
    },
    // { text: "Purchase Cost", icon: <ReceiptIcon />, to: "/purchaseCost" },
    { text: "Approval", icon: <ApprovalIcon />, to: "/approvals" },
    {
      text: "Ticket Analytics",
      icon: <AnalyticsIcon />,
      children: [
        { text: "Insights", icon: <InsightsIcon />, to: "/tickets-dashboard" },
        {
          text: "TotalReport",
          icon: <InsightsIcon />,
          to: "/fullReport",
        },

        {
          text: "GeneralReport",
          icon: <CollectionsIcon />,
          to: "/singleReport",
        },

        {
          text: "Show Performance",
          icon: <TrendingUpIcon />,
          to: "/showPerformance",
        },
        {
          text: "Revenue Analytics",
          icon: <MonetizationOnIcon />,
          to: "/reports",
        },
        {
          text: "Earnings per Booking",
          icon: <BarChartIcon />,
          to: "/totalReport",
        },
        {
          text: "Earnings per Ticket",
          icon: <AccountBalanceWalletIcon />,
          to: "/gstSplit",
        },
      ],
    },
{
  text: "Ticket Analytics V2",
  icon: <AnalyticsIcon />,
  children: [
    { text: "Insights V2", icon: <InsightsIcon />, to: "/ticket-dashboardV2" },

    { text: "TotalReport V2", icon: <InsightsIcon />, to: "/fullReportV2" },

    { text: "GeneralReport V2", icon: <CollectionsIcon />, to: "/singleReportV2" },

    { text: "Show Performance V2", icon: <TrendingUpIcon />, to: "/showPerformanceV2" },

    { text: "Revenue Analytics V2", icon: <MonetizationOnIcon />, to: "/reportV2" },

    { text: "Earnings per Booking V2", icon: <BarChartIcon />, to: "/totalReportV2" },

    { text: "Earnings per Ticket V2", icon: <AccountBalanceWalletIcon />, to: "/gstSplitV2" },
  ],
}

  ];

  // Expose Settlement to ticket-admins under Tickets
  // Removed ticket-admin injection for Settlement

  // Accounts items
  const accountsItems = [
    {
      text: "A-Payables",
      icon: <PaymentsIcon />,
      children: [
        {
          text: "Processing",
          icon: <DriveFolderUploadIcon />,
          to: "/fileUpload",
        },
        {
          text: "Settlement",
          icon: <SummarizeIcon />,
          to: "/settlementReport",
        },
      ],
    },
    {
      text: "A-Receivables",
      icon: <AttachMoneyIcon />,
      children: [
        {
          text: "Receivables Item 1",
          icon: <ReceiptIcon />,
          to: "/receivables1",
        },
        {
          text: "Receivables Item 2",
          icon: <ReceiptIcon />,
          to: "/receivables2",
        },
      ],
    },
  ];

  const accountTicketsItems = [
    {
      text: "Earnings per Booking",
      icon: <BarChartIcon />,
      to: "/totalReport",
    },
    {
      text: "Earnings per Ticket",
      icon: <AccountBalanceWalletIcon />,
      to: "/gstSplit",
    },
    {
      text: "Settlement",
      icon: <SummarizeIcon />,
      to: "/settlementReport",
    },
  ];


  const trackingItems=[
     { text: "Dashboard-Tracking", icon: <GridViewRoundedIcon />, to: "/tracking-dashboard" },
    //  { text: "Add Route", icon: <BookOnlineIcon />, to: "/add-vehicle-route" },
    { text: "vehiclesList", icon: <TheatersIcon />, to: "/vehiclesList" },
    {text:"Vehicle-Routes",icon:<DriveFolderUploadIcon/>,to:"/vehicle-routes"},
    {text:"Approval",icon:<DriveFolderUploadIcon/>,to:"/user-approvals"},

    // { text: "Manage Showtimes", icon: <ScheduleIcon />, to: "/showSchedules" },

  ]

  // Render nested menu items with reduced padding and smaller text
  const renderMenuItems = (items, level = 0) => {
    const iconBaseLeftPadding = 1.0;
    const textIndentPadding = level * 2.0;

    return items.map((item) => (
      <React.Fragment key={item.text}>
        <ListItem disablePadding sx={{ display: "block" }}>
          {item.children ? (
            <>
              <ListItemButton
                onClick={() => handleToggle(item.text)}
                sx={{
                  minHeight: 26,
                  pl: iconBaseLeftPadding,
                  py: 0,
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.04)" },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: ICON_MIN_WIDTH,
                    color: "inherit",
                    '& .MuiSvgIcon-root': {
                      fontSize: ICON_FONT_SIZE,
                    },
                    // If sidebar is closed, align the icon in the center of the available space
                    justifyContent: open ? 'flex-start' : 'center',
                    display: 'flex', // Ensure flexbox for centering
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {/* Always render the chevron/expand icon, adjust visibility and position */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    // Only apply text-related padding/margin when sidebar is open
                    ...(open && {
                      pr: 0.5,
                      pl: textIndentPadding,
                    }),
                    // When sidebar is closed, absolute position the chevron icon
                    ...(!open && {
                      position: 'absolute',
                      right: 0, // Align to the right edge
                      top: '50%',
                      transform: 'translateY(-50%)',
                      // Ensure it occupies a consistent width
                      minWidth: CHEVRON_ICON_CLOSED_MIN_WIDTH,
                      justifyContent: 'center',
                    }),
                  }}
                >
                  {openMenus[item.text] ?
                    <ExpandMoreIcon sx={{ fontSize: ICON_FONT_SIZE }} /> :
                    <ChevronRightIcon sx={{ fontSize: ICON_FONT_SIZE }} />
                  }
                </Box>
                {open && ( // Only render text when sidebar is open
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{
                      fontSize: "0.75rem",
                      style: { padding: 0, marginLeft: "4px" },
                    }}
                  />
                )}
              </ListItemButton>

              <Collapse in={openMenus[item.text]} unmountOnExit>
                <List component="div" disablePadding>
                  {renderMenuItems(item.children, level + 1)}
                </List>
              </Collapse>
            </>
          ) : (
            <ListItemButton
              component={item.to ? NavLink : 'div'}
              to={item.to}
              onClick={item.onClick}
              sx={{
                minHeight: 26,
                pl: iconBaseLeftPadding,
                py: 0,
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.04)" },
                "&.active": {
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: ICON_MIN_WIDTH,
                  color: "inherit",
                  '& .MuiSvgIcon-root': {
                    fontSize: ICON_FONT_SIZE,
                  },
                  // If sidebar is closed, align the icon in the center of the available space
                  justifyContent: open ? 'flex-start' : 'center',
                  display: 'flex',
                }}
              >
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: "0.75rem",
                    style: { padding: 0, marginLeft: `${textIndentPadding + 4}px` },
                  }}
                />
              )}
            </ListItemButton>
          )}
        </ListItem>
      </React.Fragment>
    ));
  };

  // Render section header with smaller icons and text
  const renderSectionHeader = (title, icon, toggle) => (
    <ListItemButton
      onClick={() => toggle()}
      sx={{
        minHeight: 30,
        pl: 1.0,
        py: 0,
        backgroundColor: openMenus[title] ? "#1a1f2e" : "#121621",
        borderLeft: openMenus[title] ? "3px solid #3f51b5" : "none",
        "&:hover": {
          backgroundColor: "#1a1f2e",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: ICON_MIN_WIDTH,
          color: "inherit",
          '& .MuiSvgIcon-root': {
            fontSize: HEADER_ICON_FONT_SIZE,
          },
          // If sidebar is closed, align the icon in the center of the available space
          justifyContent: open ? 'flex-start' : 'center',
          display: 'flex',
        }}
      >
        {icon}
      </ListItemIcon>
      {/* Always render the chevron/expand icon for section headers */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          // Only apply margin when sidebar is open
          ...(open && {
            mr: 0.5,
          }),
          // When sidebar is closed, absolute position the chevron icon
          ...(!open && {
            position: 'absolute',
            right: 0, // Align to the right edge
            top: '50%',
            transform: 'translateY(-50%)',
            minWidth: CHEVRON_ICON_CLOSED_MIN_WIDTH,
            justifyContent: 'center',
          }),
        }}
      >
        {openMenus[title] ?
          <ExpandMoreIcon sx={{ fontSize: ICON_FONT_SIZE }} /> :
          <ChevronRightIcon sx={{ fontSize: ICON_FONT_SIZE }} />
        }
      </Box>
      {open && ( // Only render text when sidebar is open
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            fontWeight: "bold",
            fontSize: "0.8rem",
            style: { padding: 0, marginLeft: "4px" },
          }}
        />
      )}
    </ListItemButton>
  );

  return (
    <Box sx={{ display: "flex", zIndex: "100" }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "space-between" : "flex-end",
            p: 0.5,
            flexShrink: 0,
            minHeight: "48px",
            backgroundColor: "#121621",
            borderBottom: "1px solid #2d3748",
          }}
        >
          {!isTicketAdmin && open && isTrackingAdmin && (
            <img
              src={CruzeLog}
              alt="logo"
              style={{ width: "100px", height: "auto" }}
            />
          )}

          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              color: "#b3b9c6",
              ml: open ? 0.5 : 0,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
              '& .MuiSvgIcon-root': {
                fontSize: TOGGLE_ICON_FONT_SIZE,
              }
            }}
          >
            {open ?
              <ChevronLeftIcon /> :
              <ChevronRightIcon />
            }
          </IconButton>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-track": { background: "#121621" },
            "&::-webkit-scrollbar-thumb": {
              background: "#2d3748",
              borderRadius: "3px",
              "&:hover": { background: "#4a5568" },
            },
          }}
        >
          <List sx={{ p: 0 }}>
            {/* Favourites Section */}
            {!isTicketAdmin && !isEarningsOnly && !isTrackingAdmin &&(
              <>
                {renderSectionHeader("Favourites", <StarIcon />, () =>
                  handleToggle("Favourites")
                )}
                <Collapse
                  in={openMenus["Favourites"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(favouritesItems)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )}

            {/* Travels Section */}
            {!isTicketAdmin && !isEarningsOnly && !isTrackingAdmin  &&(
              <>
                {renderSectionHeader("Travels", <CarIcon />, () =>
                  handleToggle("Travels")
                )}
                <Collapse
                  in={openMenus["Travels"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(travelsItems, 1)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )}

            {/* Masters & Config Section */}
            {!isTicketAdmin && !isEarningsOnly && !isTrackingAdmin &&(
              <>
                {renderSectionHeader("Masters & Config", <SettingsIcon />, () =>
                  handleToggle("Masters & Config")
                )}
                <Collapse
                  in={openMenus["Masters & Config"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(mastersConfigItems, 1)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )}

            {/* Marketing Section */}
            {!isTicketAdmin && !isEarningsOnly && !isTrackingAdmin &&(
              <>
                {renderSectionHeader("Marketing", <CampaignIcon />, () =>
                  handleToggle("Marketing")
                )}
                <Collapse
                  in={openMenus["Marketing"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(marketingItems, 1)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )}

            {/* Tickets Section */}
            {!isEarningsOnly && 
            !isTrackingAdmin &&(
              <>
                {renderSectionHeader(
                  "Tickets",
                  <ConfirmationNumberIcon />,
                  () => handleToggle("Tickets")
                )}
                <Collapse
                  in={openMenus["Tickets"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(ticketsItems, 1)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )}

            {/* Accounts Section */}
            {!isTicketAdmin && !isEarningsOnly && !isTrackingAdmin && (
            // {isEarningsOnly && (
              <>
                {renderSectionHeader(
                  "Accounts",
                  <AccountBalanceWalletIcon />,
                  () => handleToggle("Accounts")
                )}
                <Collapse
                  in={openMenus["Accounts"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(accountsItems, 1)}
                  </List>
                </Collapse>
              </>
            )}

            {/* JSW AUDIT */}

            {/* {!isTicketAdmin && !isEarningsOnly && ( */}
            {isEarningsOnly && !isTrackingAdmin &&(
              <>
                {renderSectionHeader(
                  "Accounts",
                  <AccountBalanceWalletIcon />,
                  () => handleToggle("Accounts")
                )}
                <Collapse
                  in={openMenus["Accounts"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderMenuItems(accountTicketsItems, 1)}
                  </List>
                </Collapse>
              </>
            )}


            {/* Tracking Section */}
            {(isTrackingAdmin || isSuperAdmin) && (
              <>
                {renderSectionHeader("Tracking", <AnalyticsIcon />, () =>
                  handleToggle("Tracking")
                )}
                <Collapse
                  in={openMenus["Tracking"]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {isSuperAdmin
                      ? owners.map((owner) => {
                          const ownerKey = `owner_${owner._id}`;
                          const ownerTrackingItems = [
                            {
                              text: "Dashboard",
                              icon: <GridViewRoundedIcon />,
                              onClick: () => handleOwnerDashboardClick(owner._id,ownerKey),
                            },
                            // Add other owner-specific items here if needed
                          ];

                          return (
                            <React.Fragment key={owner._id}>
                              <ListItemButton
                                // onClick={() => handleToggle(ownerKey)}
                                  onClick={() => handleOwnerDashboardClick(owner._id,ownerKey)}
                                sx={{
                                  minHeight: 26,
                                  pl: 2,
                                  py: 0,
                                  "&:hover": {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.04)",
                                  },
                                }}
                              >
                                <ListItemIcon
                                  sx={{
                                    minWidth: ICON_MIN_WIDTH,
                                    color: "inherit",
                                    "& .MuiSvgIcon-root": {
                                      fontSize: ICON_FONT_SIZE,
                                    },
                                  }}
                                >
                                  <AccountCircleIcon />
                                </ListItemIcon>
                                {open && (
                                  <ListItemText
                                    primary={owner.name}
                                    primaryTypographyProps={{
                                      fontSize: "0.75rem",
                                      style: { padding: 0, marginLeft: "4px" },
                                    }}
                                 
                                  />
                                )}
                                {openMenus[ownerKey] ? (
                                  <ExpandMoreIcon sx={{ fontSize: ICON_FONT_SIZE }} />
                                ) : (
                                  <ChevronRightIcon
                                    sx={{ fontSize: ICON_FONT_SIZE }}
                                  />
                                )}
                              </ListItemButton>
                              <Collapse
                                in={openMenus[ownerKey]}
                                timeout="auto"
                                unmountOnExit
                              >
                                <List component="div" disablePadding>
                                  {renderMenuItems(trackingItems, 1)}
                                </List>
                              </Collapse>
                            </React.Fragment>
                          );
                        })
                      : renderMenuItems(trackingItems, 1)}
                  </List>
                </Collapse>
                <Divider sx={{ bgcolor: "#2d3748", my: 0.5 }} />
              </>
            )} 
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Sidebar1;
